import s from './modalBody.module.css'
import Range from '../../UI/Range'
import Button from '../../UI/Button'
import { useState } from 'react'
import { convertNumberCost } from '../../../helpers/convertNumberCost'
import { useEffect } from 'react'
import { directionOrdersApi } from '../../../api'
import { useSelector } from "react-redux";
// import { useInputNew } from '../../UI/InputNew/useInputNew'
import { InputNew } from '../../UI/InputNew'
import { useGetId } from '@/hooks/useGetId'

const getDiscountedAmount = (sum, discount, type = 'р') => {
  if (type === '%') return Number((sum - (sum * discount / 100)).toFixed(2))
  return sum - discount
}


const InputCount = ({ value = 1, onChange = () => false }) => {
  let [val, setVal] = useState(value)

  useEffect(() => onChange(val), [val, onChange])

  const onInput = (e) => {
    const value = e.target.value.replace(/[^.\d]/g, "")
    var from = value.indexOf('.') + 1
    const newValue = from ? value.slice(0, from + 2) : value
    setVal(newValue)
  }

  return <input autoFocus min={1} value={val} onInput={onInput} className={s.inputCount} placeholder='5.5' />

}



const ModalBody = ({ type, data, setModal, orders, order }) => {
  const childrenId = useGetId()
  let [valRange, setValRange] = useState(1)
  let [valNumber, setValNumber] = useState(1)
  let buttonVisible = valRange >= 3 || valNumber >= 40

  let title = null;
  let privatePrice = null;
  let summ = null;

  switch (type) {
    case 'private':
      title = `Продлить индивидуальное обучение ${data?.direction?.name}`
      privatePrice = order?.privateInfo?.hour_cost ? Number(order.privateInfo.hour_cost) : data.tariff.first_price
      summ = valNumber * privatePrice
      break
    case 'group':
      title = `Продлить обучение ${data?.direction?.name}`
      privatePrice = order?.privateInfo?.hour_cost ? Number(order.privateInfo.hour_cost) : data.tariff.first_price
      summ = valRange * data.tariff.first_price
      break
    case 'class':
      title = `Продлить обучение ${data?.title}`
      privatePrice = data.payment_amount
      summ = valRange * data.payment_amount
      break
    default:
      break
  }

  const payment = async () => {
    const newData = {}

    switch (type) {
      case 'private':
        newData.order_id = data.id
        newData.buy_hour = valNumber
        break
      case 'group':
        newData.order_id = data.id
        newData.buy_months = valRange
        break
      case 'class':
        newData.class_id = data.id
        newData.buy_months = valRange
        newData.user_id = childrenId
        break
      default:
        break
    }

    let res = null;

    if (type === 'class') {
      res = await directionOrdersApi.extendClass({
        data: newData,
      })
    } else {
      res = await directionOrdersApi.extend({
        data: newData,
        params: { type: type === 'private' ? 'student-hour' : 'student-month' }
      })
    }

    if (res.data.payment_link) {
      setModal({ active: true, type: 'redirectBank', data: newData, order: res.data })
    }

    window.open(res.data.payment_link)
  }

  const [addOrders, setOrders] = useState([])

  // const ordersList = orders.filter(item => item.status_payment && item.tariff.type !== 'free')

  // const ordersListSelectOrigin = ordersList?.map(item => ({ label: item.direction.name, value: item.id })) ?? []

  const [addedCourses, setAddedCourses] = useState([])


  // const ordersListSelect = ordersListSelectOrigin?.filter(({ value }) => !addedCourses.includes(value)) ?? []



  // const addAddedCourse = (order_id) => {
  //   const newOrder = ordersList.find(({ id }) => id === order_id)
  //   setOrders([...addOrders, { id: newOrder.id, order: newOrder, value: 1, price: Number(newOrder.tariff.first_price) }])
  //   setAddedCourses([...addedCourses, order_id])
  // }

  const changeAddedCourse = (order_id, data) => {
    setOrders(addOrders.map(item => (item.id === order_id) ? { ...item, ...data } : item))
  }

  const removeAddedCourse = (order_id) => {
    setAddedCourses(addedCourses.filter(id => id !== order_id))
    setOrders(addOrders.filter(item => item.id !== order_id))
  }




  // const [bindSelectOrder] = useInputNew({
  //   placeholder: `Добавить ещё курс со скидкой ${addedCourses.length > 0 ? 8 : 6}%`,
  //   value: '',
  //   onChange: addAddedCourse,
  //   options: ordersListSelect
  // })

  let totalOld = summ
  let total = summ

  addOrders?.forEach((order, i) => {
    totalOld = totalOld + order.price
    total += getDiscountedAmount(order.price, i > 0 ? 8 : 6, '%')
  })


  if (process.env.REACT_APP_BLOCK_PAYMENT === '1') return <>
    <h2 className='modal__title'>Продлить обучение</h2>

    <p style={{ marginBottom: 20 }}>
      Чтобы продолжить обучение, Вам необходимо продлить курс.
    </p>

    <div className={s.wrap} style={{ marginBottom: 20 }}>
      Прости, данный функционал ещё на стадии разработки
    </div>

    <Button name='Закрыть' action={() => setModal({ active: false })} styles='accent' />
  </>

  return <div className={s.wrapper}>
    <h2 className="modal__title">{title}</h2>

    <div>Если Вы хотите произвести оплату за несколько месяцев/часов, то производить её нужно одним платежом (или через 20 минут после первой оплаты)</div>
    <br />
    {
      (type === 'group' || type === 'class')
        ? <>
          <p className={s.descr}>Выберите количество месяцев</p>
          <Range className={s.range} max={18} min={1} value={valRange} onChange={e => setValRange(e.target.value)} />
        </>
        : <>
          <span className={s.price}>Стоимость 1 часа - {convertNumberCost(privatePrice)} руб</span>
          <p className={s.descr}>Введите количество часов, которые вы хотите оплатить</p>
          <InputCount onChange={setValNumber} />
        </>
    }

    {/* {ordersListSelect.length > 0 && <InputSelect className={s.selectAdded} {...bindSelectOrder} />} */}

    {addedCourses.length > 0 &&
      <div className={s.addedList}>
        {addOrders.map(item => <AddedItem {...{ key: item.id, ...item, changeAddedCourse, removeAddedCourse }} />)}
      </div>
    }


    {/* <span className={s.sum}>Сумма: {convertNumberCost(summ)} руб</span> */}

    {/* <div className={s.payWrap} style={{ opacity: 0.5 }}>
      <div className={s.payWrapIn}>
        <CheckBox value={false} /> <p>Оплатить часть суммы через баланс</p>
      </div>

      <div className={s.ballance}>
        <div className={s.ballanceHead}> Баланс <span>{convertNumberCost(balance)} руб</span></div>
        <input type="text" placeholder='Введите сумму' disabled={true} />
      </div>

    </div> */}


    {addOrders.length > 0 && <div className={s.orderSum}>
      <h4 className={s.addedName}>{data?.direction?.name}: {convertNumberCost(summ)} р </h4>
      {addOrders?.map((order, i) => <h4 key={order.id} className={s.addedName}>{order.order.direction.name}: {convertNumberCost(getDiscountedAmount(order.price, i > 0 ? 8 : 6, '%'))}р <span className={s.oldPrice}>{convertNumberCost(order.price)}р</span></h4>)}

    </div>}



    <span className={s.sum}>Итого: {convertNumberCost(total)} р {addOrders?.length > 0 && <span className={s.oldPrice}>{convertNumberCost(totalOld)}р</span>}</span>

    <div className={s.buttonWrapper}>
      <Button name='Купить' styles='accent' className={s.save} action={payment} newDesign={true} />
      {buttonVisible && <>
        {/* <Button name='Оплатить в рассрочку' styles='accent' className={s.save} action={payment} disable={true} />
        <Button name='Оплатить частями' styles='accent' className={s.save} action={payment} disable={true} /> */}
      </>}

    </div>
  </div>
}

export default ModalBody

const AddedItem = ({ order, value, price, changeAddedCourse, removeAddedCourse }) => {
  const onChange = (event) => {
    const value = Number(event.target.value.replace(/[^\d]/g, ""))
    changeAddedCourse(order.id, { value, price: value * order.tariff.first_price })
  }

  return <div className={s.AddedItem}>
    <button className={`close ${s.close}`} onClick={() => removeAddedCourse(order.id)}></button>

    <h3 className={s.addedCoursesName}>{order.direction.name}</h3>
    {
      (order.tariff.type === 'month')
        ? <>
          <p className={s.descr}>Выберите количество месяцев</p>
          <Range max={18} min={1} value={value} onChange={onChange} />
        </>
        : <>
          <p className={s.descr}>Введите количество часов, которые вы хотите оплатить</p>
          <InputNew value={value} onChange={onChange} />
        </>
    }

  </div>
}
